export default "__VITE_ASSET__ajsu8ok7__"